import React, { useState } from "react";
import classNames from "classnames";
import moment from "moment";

import { DropDown } from "components/Input/Select";

import { useOutsideClickHook } from "utils/outsideClick";
import { getPvTemplate } from "utils/mechanicals";
import { maxLength } from "utils/fieldValidation";
import { createKeyboardShortcut } from "utils/keyboardShortcuts";

import classes from "./style.module.scss";

import Add from "assets/images/icons/JSX/Add";

const charLim32 = maxLength(32);

export default ({ accessor, numSystems, change }) => {
    const ref = useOutsideClickHook(() => toggleOpen(false));

    const [open, toggleOpen] = useState(false);

    const handleAddSystem = () => {
        change(`${accessor}.pvSystems.pvSystem${moment().format("YYYYMMDDHHmmssSS")}`, {
            ...getPvTemplate(),
            systemNumber: numSystems + 1,
        });
    };

    return (
        <div className={classes.addComponent} ref={ref}>
            <div
                className={classNames(classes.addText, { [classes.open]: open })}
                onClick={() => toggleOpen(!open)}
                {...createKeyboardShortcut({ onKeyDown: () => toggleOpen(!open), dropDownFocus: true })}
            >
                {numSystems < 8 ? "Add Generation" : "Solar PV System Limit Reached"}
                {numSystems < 8 && <Add />}
            </div>
            {numSystems < 8 && (
                <DropDown
                    className={classes.dropDown}
                    options={[
                        {
                            value: "pv",
                            label: "Solar PV System",
                        },
                    ]}
                    open={open}
                    toggleOpen={toggleOpen}
                    onChange={() => {
                        handleAddSystem();
                    }}
                />
            )}
        </div>
    );
};
